// src/api/support.ts

import { apiJson } from "./client";

/** Mirrors SupportTopic in apps/backend/api/routes/support_routes.py. */
export type SupportTopic = "segmentation" | "data_model" | "reporting" | "other";

export type SupportRequestPayload = {
  topic: SupportTopic;
  /** What the user was trying to achieve, in their own terms. */
  question: string;
  /** Why the platform cannot do it today, in one sentence. */
  blocker: string;
  data_source_public_id?: string;
  table?: string;
};

/**
 * POST /support/requests
 *
 * Tell the Verity team the platform cannot do something the user needs. The
 * source-bound sibling, for a BROKEN source, is `fileSupportAlert` in
 * ./managedSources.
 */
export async function fileSupportRequest(
  payload: SupportRequestPayload
): Promise<{ ok: boolean }> {
  return apiJson<{ ok: boolean }>("/support/requests", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
